/**
 * Roles the API refuses a vessel write to — the complement of VesselPolicy's admitted set
 * (MANAGER, OPS, ADMIN, OWNER, plus platform users under the blanket grant).
 *
 * Applied to the container and trailer create and edit routes so a refused user cannot
 * reach a form they cannot save, having already had the controls withheld on the list by
 * `useFleetWriteAccess`.
 *
 * **A deny list, not `allowRoles`, and not the composable.** The router guard takes only
 * arrays of role names — it has no predicate hook — so it cannot call `useFleetWriteAccess`
 * and there is nowhere to express the platform-user exception directly. An allow list would
 * express the admitted set, but the guard evaluates it with `hasAnyRole()`, which reads only
 * the tenant being administered; a platform user whose SUPER sits on the Movepro tenant has
 * an empty role list there and would be locked out of a form the API would have accepted.
 * A deny list has no such failure mode: that same user holds none of these roles either, so
 * they pass. The exception is preserved by construction rather than by a special case.
 *
 * **This is a second expression of the role split and it can drift from VesselPolicy.**
 * Keeping it in one module rather than one per route file means a change lands in a single
 * place. `fleetWriteRoutes.spec.js` asserts the property over every fleet route, so a route
 * added later without the guard fails — but no test can catch the admitted set itself
 * changing on the API without this being updated. If VesselPolicy's roles change, change
 * this too.
 *
 * @type {readonly string[]}
 */
export const VESSEL_WRITE_DENY_ROLES = Object.freeze(['SALES', 'FINANCE', 'FIELD_STAFF', 'CONTRACTOR']);
